<mat-drawer-container class="workspace network-outlet" [hasBackdrop]="false">
  <mat-drawer
    #drawer
    class="sidenav"
    position="end"
    [mode]="drawerMode$ | async"
    [opened]="!!sidenavType"
  >
    <div class="close">
      <button (click)="closeSidenavClicked()" mat-icon-button>
        <i class="material-icons-round">close</i>
      </button>
    </div>

    <div class="sidenav-content">
      @if (sidenavType === 2) {
        <app-profile
          [contact]="contact"
          [contactId]="contactId"
          [template]="'type1'"
        ></app-profile>
      }
      @if (workspaceId && (sidenavType === 1 || sidenavType === 4)) {
        <app-workspace-details
          [workspaceId]="workspaceId"
          [userAccount]="userAccount"
          [disabeleRemoveMembers]="
            !removableWorkspaceContacts || !removableWorkspaceContacts.length
          "
          [inviteMode]="sidenavType === 4"
          (workspaceUpdated)="onWorkspaceUpdated($event)"
          (userWorkspaceUpdated)="loadWorkspace()"
          (closeSidenav)="closeSidenav()"
          (removeMembersClicked)="onEditMembers()"
          (handleAddMembersClicked)="handleAddMembers(this.workspaceId)"
        ></app-workspace-details>
      }
      @if (sidenavType === 3) {
        <div class="workspace-members">
          <app-workspace-members
            [participants]="removableWorkspaceContacts"
            [workspaceId]="workspaceId"
            (closeClick)="closeSidenav()"
            (needRefresh)="refresh()"
          ></app-workspace-members>
        </div>
      }
      @if (sidenavType === 5 && userWorkspace?.workspace?.id && selectedTeam) {
        <app-role-details
          [team]="selectedTeam"
          [workspaceId]="userWorkspace.workspace.id"
          (updateTeam)="handleUpdateTeam($event)"
          (leaveTeam)="handleUpdateTeam($event)"
          (showProfile)="handleShowTeamMemberProfile($event)"
        ></app-role-details>
      }
      @if (sidenavType === 6 && selectedUserId) {
        <app-profile [contactId]="selectedUserId" [userAccount]="userAccount">
        </app-profile>
      }
    </div>
  </mat-drawer>

  @if (userWorkspace && userWorkspace.workspace) {
    <div class="outlet-content">
      <div class="network-header network-header-margin header">
        <div class="network-cover">
          <div class="cover">
            <div class="cover-background">
              <div class="cover-image"></div>
            </div>
          </div>
        </div>
        <div class="logo">
          @if (
            !isAvatarInvalid &&
            userWorkspace &&
            userWorkspace.workspace &&
            userWorkspace.workspace.profilePictureUri
          ) {
            <div>
              <app-basic-celo-avatar
                [name]="userWorkspace.workspace.name"
                [size]="120"
                [workspaceId]="userWorkspace.workspace.id"
                (imageError)="onAvatarError()"
              ></app-basic-celo-avatar>
            </div>
          }
          @if (
            isAvatarInvalid ||
            !userWorkspace.workspace ||
            !userWorkspace.workspace ||
            !userWorkspace.workspace.profilePictureUri
          ) {
            <div class="icon">
              <img src="../../../../assets/icons/ic-workplace.svg" alt="" />
            </div>
          }
        </div>
        <div class="network-header-content">
          <div class="title flex items-center">
            @if (!userWorkspace.workspace.name) {
              <span>&nbsp;</span>
            }
            @if (userWorkspace.workspace.name) {
              <span>{{ userWorkspace.workspace.name }}</span>
            }
            @if (company?.trialEndDate) {
              <span class="trial-countdown">
                <app-trial-countdown
                  [trialEndDate]="company.trialEndDate"
                ></app-trial-countdown>
              </span>
            }
          </div>
          @if (company) {
            <div class="subtitle">
              Your workspace is currently on Celo's
              {{ company.plan | planDisplayName }} subscription.
              @if (company.plan === "Free") {
                <span>
                  <a class="celo-link" [href]="upgradeUrl"> Upgrade workspace</a
                  >.
                </span>
              }
            </div>
          }
          @if (userWorkspace.workspace?.verificationStatus !== "Verified") {
            <div class="subtitle">
              <a
                href="https://support.celohealth.com/hc/en-us/articles/1500003870121"
                target="_blank"
                class="celo-link"
                >Learn more</a
              >
              about how you can verify and make changes to this workspace.
            </div>
          }
          <div class="workspace-butttons network-buttons">
            @if (
              userWorkspace &&
              userWorkspace.claims &&
              userWorkspace.claims.workspaceUserManage === "true"
            ) {
              <div class="button">
                <a
                  mat-button
                  [href]="manageUsersUrl"
                  target="_blank"
                  class="celo-primary-button"
                >
                  <div class="uppercase">
                    <span>Manage Users</span>
                  </div>
                </a>
              </div>
            }
            @if (isMyWorkspace) {
              <div class="button">
                <button
                  mat-button
                  class="celo-secondary-button"
                  (click)="viewDetailsButtonClick()"
                >
                  <div class="uppercase">
                    <span>View Details</span>
                  </div>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="content">
        <div class="search">
          <div class="searchbar">
            <div class="bar">
              <app-celo-topbar-search-input
                class="fw"
                [searchTerm]="searchTerm"
                [placeholder]="
                  'Search ' +
                  (userWorkspace?.workspace?.name
                    ? userWorkspace.workspace.name
                    : '')
                "
                (doSearch)="handleSearch($event)"
              >
              </app-celo-topbar-search-input>
            </div>
            <div
              class="celo-open-horizontal cancel"
              [style.width.px]="searchTerm ? 100 : 0"
            >
              <button
                class="celo-primary-button-blue celo-hoverable m-1"
                mat-button
                (click)="handleClearSearch()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        @if (workspaceId) {
          <div class="results">
            @if (isLoading) {
              <app-empty-state
                [spinner]="false"
                [animation]="true"
                [isLoading]="true"
                [message]="' '"
                [diameter]="36"
                [containerHeight]="350"
              ></app-empty-state>
            } @else {
              <!-- Roles/teams -->
              @if (
                (!searchTerm && teams.length) ||
                (!searchTerm && isAddRoleEnabled) ||
                (searchTerm && teamsSearchResults.length)
              ) {
                <div class="roles-container">
                  <app-workspace-list-title title="Roles">
                    @if (isAddRoleEnabled && !searchTerm && teams.length) {
                      <app-workspace-create-role-button
                        (click)="handleCreateRoleClicked()"
                        end
                      ></app-workspace-create-role-button>
                    }
                  </app-workspace-list-title>
                  <div class="spacer"></div>
                  @if (isAddRoleEnabled && !searchTerm && !teams.length) {
                    <app-workspace-create-role-button
                      (click)="handleCreateRoleClicked()"
                      fontSize="16px"
                      fontWeight="normal"
                      padding="10px 0 0 0"
                    ></app-workspace-create-role-button>
                  }
                  @if ((searchTerm ? teamsSearchResults : teams).length) {
                    <app-roles-list
                      [teams]="searchTerm ? teamsSearchResults : teams"
                      (role)="handleRoleClicked($event)"
                      avatarBackgroundSize="32px"
                      avatarSize="28px"
                    ></app-roles-list>
                  }
                </div>
              }
              <!-- Department users -->
              <app-workspace-list
                [workspaceId]="workspaceId"
                [userAccount]="userAccount"
                [searchTerm]="searchTerm"
                [groupedLocalContactsDepartments]="
                  searchTerm
                    ? groupedLocalContactsDepartmentsSearchResults
                    : groupedLocalContactsDepartments
                "
                (contact)="onCardClicked($event)"
              ></app-workspace-list>
              <!-- People -->
              @if (searchTerm) {
                <div>
                  <app-workspace-list
                    [workspaceId]="workspaceId"
                    [userAccount]="userAccount"
                    [searchTerm]="searchTerm"
                    [groupedLocalContactsDepartments]="
                      groupedLocalContactsPeople
                    "
                    (contact)="onCardClicked($event)"
                  ></app-workspace-list>
                </div>
              }
            }
            @if (searchTerm && isSearchResultsEmpty && !isLoading) {
              <div class="empty-state">
                <img
                  src="../../../assets/no-results-found-directory-v2.svg"
                  alt=""
                />
                <div class="title">No results found</div>
                <div class="subtitle">
                  You can search for people by their name, position or
                  department.
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (!userWorkspace || !userWorkspace.workspace) {
    <div>
      <app-empty-state
        [spinner]="true"
        [animation]="false"
        [isLoading]="true"
        [message]="' '"
        [diameter]="16"
        [stroke]="2"
      ></app-empty-state>
    </div>
  }
</mat-drawer-container>
